// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
    throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient<Database>(
    SUPABASE_URL, 
    SUPABASE_PUBLISHABLE_KEY, 
    {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        storageKey: 'supabase.auth.token',
    }});